module.exports = __webpack_public_path__ + "img/B557.023a5e40.jpg";